import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axiosInst from "../../../Config";
import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { Image } from "../../StyledComponents";
import { Container, RespDiv, ScrollBody } from "./styles";
import NoAppointmentImage from "../../../Assets/images/no_appt_image.png";

const PrescriptionTab = ({ onScheduleClick }) => {
  const [prescriptionList, setPrescriptionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  useEffect(() => {
    if (!Pat_ID) return;

    setLoading(true);

    // const encrypted = Encrypt_Value({ pid: Pat_ID }, "vozoportal");

    axiosInst
      .get(`/vozoportal/patient/prescriptions`, {
        params: { pid: Pat_ID }, // send encrypted pid as query param
      })
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozoportal");
        // Backend now returns a flat array (not a tuple)
        const prescriptions = Array.isArray(decrypted) ? decrypted : [];
        setPrescriptionList(prescriptions);
      })
      .catch((err) => {
        console.error(err);
        setPrescriptionList([]);
      })
      .finally(() => setLoading(false));
  }, [Pat_ID]);

  return (
    <RespDiv
      width="100%"
      height="100%"
      backColor="#FFFFFF"
      padding="0px"
      marginTop="8px"
    >
      <Container>
        {/* Header */}
        <div
          style={{
            background: "#ffffff",
            padding: "14px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "6px",
            marginBottom: "2px",
          }}
        >
          <div
            style={{ color: "#2E2E2E", fontWeight: "600", fontSize: "20px" }}
          >
            Prescription List
          </div>
        </div>

        {/* Table */}
        <div
          style={{
            width: "100%",
            margin: 0,
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
          }}
        >
          {/* Column headers */}
          <div
            style={{
              display: "grid",
              background: "#F1F5F8",
              gridTemplateColumns:
                "minmax(180px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) minmax(140px, 1fr)",
              width: "100%",
              padding: "12px 20px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#407BFF",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            <div>Prescription Name</div>
            <div>Dosage</div>
            <div>End Date</div>
            <div>Status</div>
            <div>Last Date Update</div>
          </div>

          <ScrollBody>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "260px",
                  color: "#6B7280",
                  fontSize: "14px",
                }}
              >
                Loading...
              </div>
            ) : prescriptionList.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "260px",
                }}
              >
                <Image
                  loading="lazy"
                  src={NoAppointmentImage}
                  height="230px"
                  width="308px"
                />
              </div>
            ) : (
              prescriptionList.map((item) => (
                <div
                  key={item.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "minmax(180px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) minmax(140px, 1fr)",
                    width: "100%",
                    padding: "14px 20px",
                    alignItems: "center",
                    borderBottom: "1px solid #F1F1F1",
                    fontSize: "12px",
                  }}
                >
                  {/* Prescription Name */}
                  <div style={{ fontWeight: "600" }}>{item.drug || "—"}</div>

                  {/* Dosage */}
                  <div>{item.dispense || "—"}</div>

                  {/* End Date */}
                  <div>
                    {item.start_date
                      ? new Date(item.start_date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : "—"}
                  </div>
                  {/* Status */}
                  <div>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "4px 10px",
                        borderRadius: "16px",
                        fontSize: "12px",
                        fontWeight: "500",
                        background: item.active === 1 ? "#ffffff" : "#ffffff",
                        color: item.active === 1 ? "#34A853" : "#DC2626",
                      }}
                    >
                      {/* Dot */}
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor:
                            item.active === 1 ? "#34A853" : "#DC2626",
                          display: "inline-block",
                        }}
                      />

                      {/* Text */}
                      {item.active === 1 ? "Active" : "Inactive"}
                    </span>
                  </div>

                  {/* Last Date Update */}
                  <div>
                    {item.date_modified
                      ? new Date(item.date_modified).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )
                      : "—"}
                  </div>
                </div>
              ))
            )}
          </ScrollBody>
        </div>
      </Container>
    </RespDiv>
  );
};

export default PrescriptionTab;
